<template>
    <div>
        <div style="display:flex">
            <span class="searchtips">收货信息</span>
            <div class="uni_ellipsis invoicedetail">
                <i class="el-icon-edit" @click="changePlace()"></i>
                <span @click="changePlace()">{{contactValue}}</span>
            </div>
        </div>
        <el-dialog :visible.sync="placeDialog" title="更改收货地址" width="60%">
            <place-manage
                ref="placeManage"
                @close="closePlace(arguments)"
            />
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="selectPlace"
                    >确认</el-button
                >
                <el-button type="primary" @click="placeDialog = false"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import placeManage from "./list";
export default {
    components: {
        placeManage
    },
    props:{
        contact:{
            type:String|Number,
            default:"",
        },
        cid:{
            type:Number,
            default:0,
        }
    },
    data(){
        return{
            placeDialog: false,
            contactValue:'',
        }
    },
    methods:{
        init:function(callback){
            this.getInfo(this.cid,callback);
        },
        getInfo(id,callback){
            this.$api.customercustomerDetail({id:id}).then(res=>{
                if(res.data.code==1){
                    let info = res.data.data;
                    if(callback){
                        callback(info);
                    }
                    this.updateContact(info.contact);
                }
            }).catch(
               ()=>{
                  if(callback){
                        callback();
                    }
               }
            )
        },
        updateContact(contacts){
            let ft = null;
            if(this.contact>0){
                ft = contacts.filter((item) => item.id == this.contact);
            }else{
                ft = contacts.filter((item) => item.main == 1);
            }
            let contact = "";
            if (ft.length > 0) {
                contact = ft[0].id;
                this.contactValue =
                    "收货人: " +
                    ft[0].name +
                    ",联系电话: " +
                    (ft[0].phone ? ft[0].phone : "无") +
                    ",收货地址: " +
                    ft[0].district.toString().replaceAll(",", "") +
                    ft[0].address;
            } else {
                if (contacts.length > 0) {
                    contact = contacts[0].id;
                    this.contactValue =
                        "收货人: " +
                        contacts[0].name +
                        ",联系电话: " +
                        (contacts[0].phone ? contacts[0].phone : "无") +
                        ",收货地址: " +
                        (contacts[0].district.toString() && contacts[0].address
                            ? contacts[0].district.toString().replaceAll(",", "") +
                              contacts[0].address
                            : "无");
                } else {
                    this.contactValue = "暂无收货信息";
                }
            }
            if(contact>0){
                this.$emit("setContact",contact);
            }
        },
        changePlace() {
            this.placeDialog = true;
            this.$nextTick(() => {
                this.$refs.placeManage.getList(
                    this.cid,
                    this.contact,
                );
            });
        },
        closePlace(value) {
            var place = value[0];
            this.$emit("setContact",place.id);
            this.contactValue =
                "收货人: " +
                place.name +
                ",联系电话: " +
                (place.phone ? place.phone : "无") +
                ",收货地址: " +
                (place.district.toString() && place.address
                    ? place.district.toString().replaceAll(",", "") +
                      place.address
                    : "无");
            this.placeDialog = false;
        },
        selectPlace() {
            this.$nextTick(() => {
                this.$refs.placeManage.checkPlace();
            });
        },
    }
}
</script>
<style scoped>
.invoicedetail{
    width:400px;
    flex-grow:1;
    line-height:40px;
    font-size:14px;
    color: #409EFF;
}
.invoicedetail span{
    cursor: pointer;
    font-size: 12px;
}
.invoicedetail i{
    cursor: pointer;
}
</style>